import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
export default {
  name: 'SvgIcon',
  props: {
    prefix: {
      type: String,
      default: 'icon'
    },
    name: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: '#333'
    },
    size: {
      type: String,
      default: '1em'
    }
  },
  computed: {
    symbolId: function symbolId() {
      return "#".concat(this.prefix, "-").concat(this.name);
    }
  }
};